<template>
  <section>
    <div class="row">
      <div
        id="loadingmessage"
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading"
      >
        <p style="position: absolute; color: White; top: 40%; left: 40%;">
          <img src="../../../assets/snakes.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              REPORT DETAILS &nbsp;
              <!-- <router-link :to="'/sightingsloc1/'+this.id ">
                <span>
                  <i style="color:red!important" class="fa fa-map-marker"></i>
                </span>
              </router-link>-->
            </h4>
            <div class="row pt-4">
              <!-- <div class="col-2">
                <div class="row pl-3">
                    <enlargeable-image v-if="im" v-bind:src="image" v-bind::src_large="image">
                    <img :src="image" v-if="im" style="width:100%;height:auto;" />
                    </enlargeable-image>
                </div>
              </div> -->

              <div class="col-md-6" v-if="data != ''">
                <table class="table table-white flex md12">
                  <thead>
                    <tr>Report Details</tr>
                  </thead>
                  <tbody>
                    <tr v-if="data.reportId">
                      <th scope="col">Description</th>
                      <td>{{data.reportId.description}}</td>
                    </tr>
                    <tr v-if="data.reportId">
                      <th scope="col">Snake</th>
                      <td v-if="data.reportId.snake">{{data.reportId.snake.name}}</td>
                      <td v-else>Not Known</td>
                    </tr>
                    <tr v-if="data.reportId && (data.reportId.createdAt || data.reportedAt)">
                      <th scope="col">Created At</th>
                      <td>{{ (data.reportId.createdAt || data.reportedAt).slice(0,10) }}</td>
                    </tr>
                    <tr v-if="data.reportId">
                      <th scope="col">Situation</th>
                      <td>{{data.reportId.situation}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Division Name</th>
                      <td v-if="data.division && data.division.length > 0">{{data.division[0].divisionName}}</td>
                      <td v-else>N/A</td>
                    </tr>
                     <tr>
                      <th scope="col">District</th>
                      <td>{{data.district}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="col-md-6" v-if="data != ''">
                <table class="table table-white flex md12">
                  <thead>
                    <tr>Reported By</tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Name</th>
                      <td>{{ (data.reportId.user && data.reportId.user.name) || data.reportId.informername || "N/A" }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Phone</th>
                      <td>{{ (data.reportId.user && data.reportId.user.phone) || data.reportId.phone || "N/A" }}</td>
                    </tr>
                    <tr v-if="data.reportId && data.reportId.user && data.reportId.user.email">
                      <th scope="col">Email</th>
                      <td>{{ data.reportId.user.email }}</td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
             <hr>
                <div class="col-md-12">
              <p><b>Photographs</b></p>
              <div class="images" v-viewer="{movable: false}">
      <img style="
    vertical-align: middle;
    border-style: none;
    width: 10%;
    height: auto;
    padding-left: 10px;padding-bottom:10px;" v-for="src in reportedimages" :src="src" :key="src">
    </div>
              </div>
              <hr>
              <div class="col-md-12">
                <div :id="'map-assign-' + id" class="google-map"></div>
              </div>
            <br><br>
              <div class="col-md-12">
              <div class="row">
                 <div class="col-md-4">
                  <button v-b-modal.modal-footer-sm-close class="btn btn-warning">Close Operation</button>
            </div>
             <div class="col-md-4">
                <button class="btn btn-danger" @click="deleteItem()">Delete Operation</button>
             </div>
             <div class="col-md-4">
                <button class="btn btn-primary" @click="openAssignModal()">Assign Operation</button>
             </div>
              </div>
            </div>
             <b-modal id="modal-footer-sm-close" title button-size="sm">
                  <form @submit="close">
                   
                   
                    <div class="form-group">
                      <label for="exampleInputEmail1">Remarks</label>
                      <textarea
                        class="form-control"
                        id="exampleInputEmail1"
                        v-model="closingremarks"
                        aria-describedby="emailHelp"
                        placeholder="Remarks"
                        rows="10"
                        
                      />
                    </div>
                    <button class="btn btn-success" type="submit">SUBMIT</button>
                  </form>
                 </b-modal>

                 <b-modal id="modal-assign-rescuers" title="Assign Rescuer" size="lg" hide-footer>
                   <div v-if="fetchingRescuers" class="text-center p-3">
                     <b-spinner label="Spinning"></b-spinner>
                     <p>Fetching nearest rescuers...</p>
                   </div>
                   <div v-else>
                     <div class="table-responsive">
                       <table class="table">
                         <thead>
                           <tr>
                             <th>Rescuer</th>
                             <th>Distance (km)</th>
                             <th>Rescues</th>
                             <th>Action</th>
                           </tr>
                         </thead>
                         <tbody>
                           <tr v-for="res in nearestRescuers" :key="res._id">
                             <td>
                               <img :src="'https://sarpatnapi.leopardtechlabs.in/u/' + res.user.photo" class="mr-2" style="width:30px;height:30px;border-radius:50%;" v-if="res.user && res.user.photo" />
                               {{ res.user ? res.user.name : 'Unknown' }}
                             </td>
                             <td>{{ res.distance ? res.distance.toFixed(2) : 'N/A' }}</td>
                             <td>{{ res.noOfRescues }}</td>
                             <td>
                               <button class="btn btn-sm btn-success" @click="assignRescuer(res.user._id)">Assign</button>
                             </td>
                           </tr>
                         </tbody>
                       </table>
                     </div>
                     <div v-if="nearestRescuers.length === 0" class="text-center p-3">
                       No nearby rescuers found.
                     </div>
                   </div>
                 </b-modal>
            <!-- <div class="row">
                  <form @submit="assign">
    

                    <div class="form-group">
                      <h4 for="exampleInputEmail1">Assign to Rescuer</h4>
                      <br>
                      <div class="col-md-12">
                        <b-checkbox
                          v-for="itm in item"
                          :key="itm._id"
                          v-bind:value="itm.user._id"
                          name="flavour-4a"
                          v-model="assignedTo"
                        >
                          <div class="pb-2">
                            <div class="px-2 pl-1 pr-5">
                              <span class="row">
                                <span class="col-md-2">
                                  <img
                                    :src="'https://sarpatnapi.leopardtechlabs.in/u/'+itm.user.photo"
                                    class="circular--square"
                                    style="width:30px;height:30px;"
                                  />
                                </span>
                                <span class="col-md-10" style="padding-right:10px;">
                                  {{ itm.user.name }}<br>
                                  No of Rescues : {{itm.noOfRescues}}
                                </span>
                              </span>
                            </div>
                          </div>
                        </b-checkbox>
                      </div>
                    </div>

                    <button class="btn btn-success" type="submit">ASSIGN</button>
                  </form>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
import EnlargeableImage from "@diracleo/vue-enlargeable-image";
var marker;
export default {
  components: {
    EnlargeableImage,
  },
  name: "myprofile",
  props: ["id"],
  data() {
    return {
      image: null,
      name: "",
      data: '',
      userdata: [],
      loading: false,
      im: "",
      rescuerCode: "",
      idType: "",
      idNumber: "",
      reason: "",
      divisionid: "",
      assignedTo: "",
      item: [],
      option: [],
       oMarker: [],
       reportedimages: [],
       closingremarks: "",
        nearestRescuers: [],
        fetchingRescuers: false,
    };
  },
  mounted: function () {
    setTimeout(() => {
      this.initMap();
      this.getview();
    }, 500);
  },

  methods: {
    initMap() {
      if (typeof google === 'undefined') {
        console.error("Google Maps API not loaded");
        return;
      }
      var mapCanvas = document.getElementById('map-assign-' + this.id);
      if (!mapCanvas) {
        console.error("Map element map-assign-" + this.id + " not found!");
        return;
      }
      var mapOptions = {
        center: new google.maps.LatLng(10.8505, 76.2711),
        zoom: 7,
        // eslint-disable-next-line
        mapTypeId: google.maps.MapTypeId.HYBRID
      };
      var vm = this;
      // eslint-disable-next-line
      vm.map = new google.maps.Map(mapCanvas, mapOptions);
    },
    getview() {
      this.loading = true;
      var vm = this;
      axios({
        method: "GET",
        url: "https://sarpatnapi.leopardtechlabs.in/operation/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { id: this.id },
      })
      .then((response) => {
        if (response.data.status === true) {
          this.data = response.data.data;
          this.$nextTick(() => {
            try {
              console.log("Operation Data:", this.data);
              
              // 1. Set Map Center if location exists
              if (this.data && this.data.reportId && this.data.reportId.location && this.data.reportId.location.length > 0) {
                var centerLat = this.data.reportId.location[1];
                var centerLng = this.data.reportId.location[0];
                if (centerLat > 40 && centerLng < 20) {
                  var tempSwap = centerLat; centerLat = centerLng; centerLng = tempSwap;
                }
                if (vm.map && centerLat !== undefined && centerLng !== undefined) {
                  vm.map.setCenter(new google.maps.LatLng(centerLat, centerLng));
                }
              }

              // 2. Process Reported Images
              var tempImages = response.data.reportedimages || (response.data.data && response.data.data.photographs) || [];
              this.reportedimages = [];
              for (var j = 0; j < tempImages.length; j++) {
                var photoUrl = typeof tempImages[j] === 'string' ? tempImages[j] : tempImages[j].photo;
                if (photoUrl) {
                  this.reportedimages.push("https://sarpatnapi.leopardtechlabs.in/u/" + photoUrl);
                }
              }

              // 3. User & Division Info
              if (response.data.data) {
                this.userdata = response.data.data.user || [];
                if (response.data.data.reportId) {
                  this.im = response.data.data.reportId.pic;
                  if (this.im !== null) {
                    this.image = "https://sarpatnapi.leopardtechlabs.in/u/" + this.im;
                  }
                }
                if (response.data.data.division && response.data.data.division.length > 0) {
                  this.divisionid = response.data.data.division[0]._id;
                  this.division = response.data.data.division;
                }
              }

              // 4. Map Markers
              var markers = [];
              if (this.data && this.data.reportId && this.data.reportId.location && this.data.reportId.location.length > 0) {
                markers.push({
                  lat: this.data.reportId.location[1], // Latitude
                  lon: this.data.reportId.location[0], // Longitude
                  type: 'Reported Location'
                });
              }

              if (markers.length > 0 && vm.map) {
                var bounds = new google.maps.LatLngBounds();
                for (var i = 0; i < markers.length; i++) {
                  var l_lat = markers[i].lat;
                  var l_lon = markers[i].lon;

                  // Robust Tamil Nadu coordinate check (TN is ~8-14N, 76-80E)
                  if (l_lat > 40 && l_lon < 20) { // If clearly swapped (e.g. Lat=78, Lon=11)
                    var tempS = l_lat; l_lat = l_lon; l_lon = tempS;
                  }

                  if (l_lat !== undefined && l_lon !== undefined) {
                    var latlngset = new google.maps.LatLng(l_lat, l_lon);
                    bounds.extend(latlngset);
                    
                    var iconUrl = "http://maps.google.com/mapfiles/kml/pal4/icon49.png";
                    
                    var mInstance = new google.maps.Marker({
                      map: vm.map,
                      position: latlngset,
                      title: markers[i].type,
                      icon: iconUrl
                    });
                    
                    var contentStr = "<strong>" + markers[i].type + "</strong><br>Lat: " + l_lat.toFixed(6) + "<br>Lon: " + l_lon.toFixed(6);
                    var info = new google.maps.InfoWindow();
                    google.maps.event.addListener(mInstance, "click", (function (m, c, f) {
                      return function () { f.setContent(c); f.open(vm.map, m); };
                    })(mInstance, contentStr, info));
                  }
                }
                vm.map.fitBounds(bounds);
                if (markers.length === 1) {
                  google.maps.event.addListenerOnce(vm.map, 'bounds_changed', function() {
                    vm.map.setZoom(14);
                  });
                }
              }
              
              this.getList();
            } catch (err) {
              console.error("Error initializing view:", err);
            } finally {
              this.loading = false;
            }
          });
        } else {
          this.loading = false;
        }
      })
      .catch((err) => {
        console.error("API error:", err);
        this.loading = false;
        alert("Error loading data!!");
      });
    },
    getList() {
      this.visible = true;
      axios({
        method: "GET",
        url: "https://sarpatnapi.leopardtechlabs.in/rescuer/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { division: this.divisionid },
      })
        .then((response) => {
          this.visible = false;

          if (response.data.status === true) {
            this.item = response.data.data;
            console.log("items1", this.item);
            this.visible = false;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((e) => {
          this.visible = false;
          // this.errors.push(e)
          this.msg = "failed";
        });
    },
    assign(evt1) {
      this.loading = true;

      evt1.preventDefault();
      axios({
        method: "GET",

        url: "https://sarpatnapi.leopardtechlabs.in/operation/assign",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { reportid: this.id, userid: this.assignedTo },
      })
        .then((response) => {
          if (response.data.status) {
            alert("Assigned Successfully");
            this.$router.push("/pending");
          } else {
            alert(response.data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
          this.loading = true;
        });
    },
           deleteItem: function (item) {
        if (confirm("Are you sure?")) {
      var vm = this;
      vm.item = this.id;
      axios({
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        url: "https://sarpatnapi.leopardtechlabs.in/operation/delete",
        data: {
          id: vm.item,
        },
      })
        .then((response) => {
          alert("Operation was successfully Deleted");
           this.$router.push("/pending/");
        })
        .catch((e) => {});
          }
    },
        close(evt) {
      this.loading = true;
      var data = {};
      data["id"] = this.id;
      data["remarks"] = this.closingremarks;
      evt.preventDefault();
      axios({
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        url: "https://sarpatnapi.leopardtechlabs.in/operation/closereport",
        data: data,
      })
        .then((response) => {
          if (response.data.status) {
            alert("Operation Closed Successfully");
            this.$router.push("/pending");
          } else {
            alert(response.data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
          this.loading = true;
        });
    },
    openAssignModal() {
      this.$bvModal.show('modal-assign-rescuers');
      this.getNearestRescuers();
    },
    getNearestRescuers() {
      if (!this.data || !this.data.reportId || !this.data.reportId.location || this.data.reportId.location.length === 0) {
        alert("Location data not found for this operation.");
        return;
      }
      this.fetchingRescuers = true;
      var lon = this.data.reportId.location[0];
      var lat = this.data.reportId.location[1];
      
      // Robust coordinate check as seen in getview()
      if (lat > 40 && lon < 20) {
        var tempSwap = lat; lat = lon; lon = tempSwap;
      }

      axios({
        method: "GET",
        url: "https://sarpatnapi.leopardtechlabs.in/rescuer/assigngetlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { 
          lat: lat, 
          lon: lon, 
          distance: 100000, // Large distance to find any available rescuer, backend handles sorting
          removeengaged: true 
        },
      })
      .then((response) => {
        this.fetchingRescuers = false;
        if (response.data.status) {
          this.nearestRescuers = response.data.data;
        } else {
          this.nearestRescuers = [];
          console.error("Failed to fetch nearest rescuers:", response.data.msg);
        }
      })
      .catch((err) => {
        this.fetchingRescuers = false;
        console.error("Error fetching nearest rescuers:", err);
      });
    },
    assignRescuer(rescuerUserId) {
      if (!confirm("Are you sure you want to assign this rescuer?")) return;
      
      this.loading = true;
      axios({
        method: "GET",
        url: "https://sarpatnapi.leopardtechlabs.in/operation/assign",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { reportid: this.id, userid: rescuerUserId },
      })
      .then((response) => {
        this.loading = false;
        if (response.data.status) {
          alert("Assigned Successfully");
          this.$bvModal.hide('modal-assign-rescuers');
          this.$router.push("/pending");
        } else {
          alert(response.data.msg || "Assignment failed");
        }
      })
      .catch((e) => {
        this.loading = false;
        console.error("Error assigning rescuer:", e);
        alert("An error occurred during assignment.");
      });
    },
  },
};
</script>
<style>
.modal-footer {
  display: none !important;
}
.circular--square {
  border-top-left-radius: 50% 50%;
  border-top-right-radius: 50% 50%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
.google-map {
  height: 350px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/operation/assign.vue